export default __webpack_public_path__ + "static/media/NotoSansKR-Light.f2dd937d.woff2";